import { render } from "./BrainBoxLogo.vue?vue&type=template&id=32b08309"
import script from "./BrainBoxLogo.vue?vue&type=script&lang=js"
export * from "./BrainBoxLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__